<template>
  <div class="result">
    <h1>Calculation Results</h1>
    <div v-if="result">
      <p>Discount Rate: {{ (result.discountRate * 100).toFixed(4) }}%</p>
      <p>Present Value -Premium: {{ result.totalPresentValue.toFixed(2) }}</p>
      <p>Present Value -Return: {{ result.presentValueOfReturn.toFixed(2) }}</p>
    </div>
    <div v-else>
      <p>No result available.</p>
    </div>
    <router-link to="/" class="back-link">Back to Calculator</router-link>
  </div>
</template>
<script>
export default {
  computed: {
    result() {
      return this.$store.state.result;
    },
  },
};
</script>
<style scoped>
.result {
  padding: 20px;
  max-width: 480px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

h1 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
}

p {
  font-size: 18px;
  margin-bottom: 10px;
}

.back-link {
  display: block;
  margin-top: 20px;
  text-align: center;
  font-size: 18px;
  color: #007bff;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}
</style>